import React, { useEffect, useState } from 'react';
import api from '../../utils/api';

export default function AdminAbout() {
  const [form, setForm] = useState({ title: '', content: '', metaDescription: '' });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState(null);

  useEffect(() => {
    api.get('/about').then(({ data }) => {
      if (data.about) setForm({ title: data.about.title || '', content: data.about.content || '', metaDescription: data.about.metaDescription || '' });
    }).finally(() => setLoading(false));
  }, []);

  const handleSave = async (e) => {
    e.preventDefault(); setSaving(true); setMessage(null);
    try {
      await api.put('/about', form);
      setMessage({ type: 'success', text: '✅ About page updated successfully!' });
    } catch (err) {
      setMessage({ type: 'error', text: err.response?.data?.message || 'Error saving' });
    } finally { setSaving(false); }
  };

  if (loading) return <div className="loading-spinner"><div className="spinner" /></div>;

  return (
    <div>
      <h1 style={{ fontFamily: 'var(--font-display)', fontSize: 24, marginBottom: 8 }}>ABOUT PAGE</h1>
      <p style={{ color: 'var(--text-secondary)', marginBottom: 32 }}>Edit the public About page content.</p>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 24 }}>
        {/* Editor */}
        <div className="card" style={{ padding: 32 }}>
          <h2 style={{ fontFamily: 'var(--font-display)', fontSize: 16, marginBottom: 20, color: 'var(--accent-cyan)' }}>EDITOR</h2>
          {message && (
            <div style={{ background: message.type === 'success' ? 'rgba(16,185,129,0.1)' : 'rgba(239,68,68,0.1)', border: `1px solid ${message.type === 'success' ? 'rgba(16,185,129,0.3)' : 'rgba(239,68,68,0.3)'}`, borderRadius: 8, padding: '10px 14px', color: message.type === 'success' ? '#10b981' : '#ef4444', marginBottom: 20, fontSize: 14 }}>{message.text}</div>
          )}
          <form onSubmit={handleSave}>
            <div className="form-group">
              <label>Page Title *</label>
              <input value={form.title} onChange={e => setForm({ ...form, title: e.target.value })} required />
            </div>
            <div className="form-group">
              <label>Meta Description</label>
              <input value={form.metaDescription} onChange={e => setForm({ ...form, metaDescription: e.target.value })} placeholder="SEO description" />
            </div>
            <div className="form-group">
              <label>Content *</label>
              <textarea
                value={form.content}
                onChange={e => setForm({ ...form, content: e.target.value })}
                rows={16}
                required
                placeholder="Write about page content here... Use double line breaks to separate paragraphs."
                style={{ resize: 'vertical', lineHeight: 1.7 }}
              />
              <span style={{ fontSize: 12, color: 'var(--text-muted)' }}>Tip: Use two line breaks to create separate paragraphs.</span>
            </div>
            <button type="submit" className="btn btn-primary" style={{ width: '100%' }} disabled={saving}>
              {saving ? 'Saving...' : '💾 Save Changes'}
            </button>
          </form>
        </div>

        {/* Preview */}
        <div className="card" style={{ padding: 32 }}>
          <h2 style={{ fontFamily: 'var(--font-display)', fontSize: 16, marginBottom: 20, color: 'var(--accent-cyan)' }}>LIVE PREVIEW</h2>
          <div style={{ background: 'var(--bg-primary)', border: '1px solid var(--border)', borderRadius: 10, padding: '24px 20px', minHeight: 300 }}>
            <h1 style={{ fontFamily: 'var(--font-display)', fontSize: 24, marginBottom: 20, background: 'var(--gradient-primary)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>{form.title || 'Page Title'}</h1>
            {form.content ? (
              form.content.split('\n\n').map((para, i) => (
                <p key={i} style={{ color: 'var(--text-secondary)', fontSize: 15, marginBottom: 16, lineHeight: 1.8 }}>{para}</p>
              ))
            ) : (
              <p style={{ color: 'var(--text-muted)', fontStyle: 'italic' }}>Your content will appear here as you type...</p>
            )}
          </div>
          <div style={{ marginTop: 16, padding: '12px 16px', background: 'var(--bg-secondary)', borderRadius: 8, fontSize: 13, color: 'var(--text-secondary)' }}>
            <strong style={{ color: 'var(--text-primary)' }}>Meta:</strong> {form.metaDescription || <em>No meta description set</em>}
          </div>
        </div>
      </div>
    </div>
  );
}
